/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type {
  OffsetDateTime,
  LocalDate,
} from "@freightsimple/time/branded-types";

import { mapValues } from "../runtime";
import type { CarrierDocumentType } from "./CarrierDocumentType";
import {
  CarrierDocumentTypeFromJSON,
  CarrierDocumentTypeFromJSONTyped,
  CarrierDocumentTypeToJSON,
  CarrierDocumentTypeToJSONTyped,
} from "./CarrierDocumentType";

/**
 *
 * @export
 * @interface CarrierDocuments
 */
export interface CarrierDocuments {
  /**
   *
   * @type {string}
   * @memberof CarrierDocuments
   */
  carrierDocumentId?: string;
  /**
   *
   * @type {CarrierDocumentType}
   * @memberof CarrierDocuments
   */
  documentType?: CarrierDocumentType;
  /**
   *
   * @type {string}
   * @memberof CarrierDocuments
   */
  documentName?: string;
  /**
   *
   * @type {string}
   * @memberof CarrierDocuments
   */
  documentS3Key?: string;
  /**
   *
   * @type {string}
   * @memberof CarrierDocuments
   */
  thumbnailS3Key?: string;
  /**
   *
   * @type {string}
   * @memberof CarrierDocuments
   */
  description?: string;
  /**
   *
   * @type {string}
   * @memberof CarrierDocuments
   */
  contentType?: string;
  /**
   *
   * @type {string}
   * @memberof CarrierDocuments
   */
  carrierIdentifier?: string;
  /**
   *
   * @type {boolean}
   * @memberof CarrierDocuments
   */
  isCurrent?: boolean;
  /**
   *
   * @type {LocalDate}
   * @memberof CarrierDocuments
   */
  dateReceived?: LocalDate;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof CarrierDocuments
   */
  uploadedAt?: OffsetDateTime;
  /**
   *
   * @type {string}
   * @memberof CarrierDocuments
   */
  uploadedBy?: string;
  /**
   *
   * @type {string}
   * @memberof CarrierDocuments
   */
  referenceNumber?: string;
  /**
   *
   * @type {boolean}
   * @memberof CarrierDocuments
   */
  isSigned?: boolean;
  /**
   *
   * @type {string}
   * @memberof CarrierDocuments
   */
  contentHash?: string;
}

/**
 * Check if a given object implements the CarrierDocuments interface.
 */
export function instanceOfCarrierDocuments(
  value: object,
): value is CarrierDocuments {
  return true;
}

export function CarrierDocumentsFromJSON(json: any): CarrierDocuments {
  return CarrierDocumentsFromJSONTyped(json, false);
}

export function CarrierDocumentsFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CarrierDocuments {
  if (json == null) {
    return json;
  }
  return {
    carrierDocumentId:
      json["carrierDocumentId"] == null ? undefined : json["carrierDocumentId"],
    documentType:
      json["documentType"] == null
        ? undefined
        : CarrierDocumentTypeFromJSON(json["documentType"]),
    documentName:
      json["documentName"] == null ? undefined : json["documentName"],
    documentS3Key:
      json["documentS3Key"] == null ? undefined : json["documentS3Key"],
    thumbnailS3Key:
      json["thumbnailS3Key"] == null ? undefined : json["thumbnailS3Key"],
    description: json["description"] == null ? undefined : json["description"],
    contentType: json["contentType"] == null ? undefined : json["contentType"],
    carrierIdentifier:
      json["carrierIdentifier"] == null ? undefined : json["carrierIdentifier"],
    isCurrent: json["isCurrent"] == null ? undefined : json["isCurrent"],
    dateReceived:
      json["dateReceived"] == null ? undefined : json["dateReceived"],
    uploadedAt: json["uploadedAt"] == null ? undefined : json["uploadedAt"],
    uploadedBy: json["uploadedBy"] == null ? undefined : json["uploadedBy"],
    referenceNumber:
      json["referenceNumber"] == null ? undefined : json["referenceNumber"],
    isSigned: json["isSigned"] == null ? undefined : json["isSigned"],
    contentHash: json["contentHash"] == null ? undefined : json["contentHash"],
  };
}

export function CarrierDocumentsToJSON(json: any): CarrierDocuments {
  return CarrierDocumentsToJSONTyped(json, false);
}

export function CarrierDocumentsToJSONTyped(
  value?: CarrierDocuments | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    carrierDocumentId: value["carrierDocumentId"],
    documentType: CarrierDocumentTypeToJSON(value["documentType"]),
    documentName: value["documentName"],
    documentS3Key: value["documentS3Key"],
    thumbnailS3Key: value["thumbnailS3Key"],
    description: value["description"],
    contentType: value["contentType"],
    carrierIdentifier: value["carrierIdentifier"],
    isCurrent: value["isCurrent"],
    dateReceived: value["dateReceived"],
    uploadedAt: value["uploadedAt"],
    uploadedBy: value["uploadedBy"],
    referenceNumber: value["referenceNumber"],
    isSigned: value["isSigned"],
    contentHash: value["contentHash"],
  };
}
